import { render } from "./TicketPageTecnico.vue?vue&type=template&id=44b22b3f&scoped=true"
import script from "./TicketPageTecnico.vue?vue&type=script&lang=js"
export * from "./TicketPageTecnico.vue?vue&type=script&lang=js"

import "./TicketPageTecnico.vue?vue&type=style&index=0&id=44b22b3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b22b3f"]])

export default __exports__